import { Button, Center, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import { TFeesTable } from './CardProductMixedHandler';

export type TMiscellaneousPeriodicFeesDataTableData = {
  primaryKey: string | number;
  id: string;
  name: string;
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any, feesTableName: TFeesTable) => void,
};

const columnHelper = createColumnHelper<TMiscellaneousPeriodicFeesDataTableData>();

export function getMiscellaneousPeriodicFeesDataTableColumns({
  isLoading,
  handleEdit,
}: Props) {
  return [
    
    columnHelper.accessor('id', {
      id: 'id',
      header: 'ID',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            {props.getValue()}
          </Skeleton>
        );
      },
    }),
    columnHelper.accessor('name', {
      id: 'name',
      header: 'Nom',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            {props.getValue()}
          </Skeleton>
        );
      },
    }),
    

    columnHelper.display({
      id: 'action',
      header: '',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>
              <Button
                size={'sm'}
                onClick={() => handleEdit(props.row, 'miscellaneousPeriodicFees')}
                mr={'1rem'}
              >
                Editer
              </Button>
            </Center>
          </Skeleton>
        );
      },
    }),
  ];
}
